import { failureType, requestType, successType } from 'src/services/api-handlers/api-resolver';
import { Paginated } from '../../services/api-handlers/pagination';

import { Actions } from '../actions/caseNoPrincipal-actions';
import { CaseNoPrincipalActions } from '../constants';
import { ICaseNoPrincipal } from 'src/types/caseNoPrincipal';

export interface CaseNoPrincipalState {
    inProgress: boolean;
    authCode: string;
    error: string;
    data: Paginated<ICaseNoPrincipal>;
    current: ICaseNoPrincipal | null;
    currentFiles: any | null;
}

const initialState = {
    inProgress: false,
    authCode: '',
    error: '',
    data: {
        inProgress: false,
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
    },
    current: null,
    currentFiles: null,
};

export function casesNoPrincipal(
    state: CaseNoPrincipalState = initialState,
    action: Actions | any,
): CaseNoPrincipalState {
    switch (action.type) {
        case requestType(CaseNoPrincipalActions.PERSIST_CASE_NO_PRINCIPAL):
            return { ...state, error: '', inProgress: true };
        case successType(CaseNoPrincipalActions.PERSIST_CASE_NO_PRINCIPAL):
            return { ...state, inProgress: false };
        case failureType(CaseNoPrincipalActions.PERSIST_CASE_NO_PRINCIPAL):
            return { ...state, error: action.error, inProgress: false };

        case requestType(CaseNoPrincipalActions.FETCH_CASE_NO_PRINCIPALS):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: [],
                    meta: state.data?.meta?.updatedAt
                        ? state.data?.meta
                        : {
                              updatedAt: null,
                          },
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(CaseNoPrincipalActions.FETCH_CASE_NO_PRINCIPALS):
            return { ...state, data: { ...action.payload, inProgress: false }, inProgress: false };
        case failureType(CaseNoPrincipalActions.FETCH_CASE_NO_PRINCIPALS):
            return { ...state, data: { ...state.data, inProgress: false }, error: action.error, inProgress: false };

        case requestType(CaseNoPrincipalActions.FETCH_CASE_NO_PRINCIPAL):
            return { ...state, inProgress: true, current: null, error: '' };
        case successType(CaseNoPrincipalActions.FETCH_CASE_NO_PRINCIPAL):
            return { ...state, inProgress: false, current: action.payload };
        case failureType(CaseNoPrincipalActions.FETCH_CASE_NO_PRINCIPAL):
            return { ...state, inProgress: false, error: action.error };
        case requestType(CaseNoPrincipalActions.DELETE_CASE_NO_PRINCIPAL):
            return { ...state, error: '', inProgress: true };
        case successType(CaseNoPrincipalActions.DELETE_CASE_NO_PRINCIPAL):
            return {
                ...state,
                inProgress: false,
                data: {
                    ...state.data,
                    list: state.data.list.filter((user: ICaseNoPrincipal) => {
                        return user.id !== action.payload.id;
                    }),
                    meta: {
                        updatedAt: 0,
                    },
                },
            };
        case failureType(CaseNoPrincipalActions.DELETE_CASE_NO_PRINCIPAL):
            return { ...state, inProgress: false, error: action.error.response.data?.errorMessage ?? 'Unknown error' };
        default:
            return state;
    }
}
